import React, { useCallback, useMemo } from "react";
import { TemplateVariable } from "../../model/accounting/template/TemplateVariable.js";
import { FormRow } from "../../../packages/ui/form/FormRow.js";
import { Input } from "../../../packages/ui/form/Input.js";
import { findVariableErrors } from "../../model/accounting/template/findVariableErrors.js";
import { useTemplate } from "./TemplateProvider.js";

type Props = {
  variable: TemplateVariable;
};

/**
 * Renders one template variable input.
 */
export const TemplateInput = ({ variable }: Props) => {
  const { values, setValue, errors } = useTemplate();

  const handleChange = useCallback(
    (value: string) => {
      setValue(variable.name, value);
    },
    [setValue, variable.name]
  );

  const value = useMemo(() => {
    return values.find((item) => item.name === variable.name)?.value ?? "";
  }, [values, variable.name]);

  const errorMessage = useMemo(() => {
    const errorMessages = findVariableErrors(variable.name, errors);
    return errorMessages.length > 0 ? errorMessages.join(" ") : undefined;
  }, [errors, variable.name]);

  return (
    <FormRow columns={1}>
      {(variable.type === "text" || variable.type === "amount_eur") && (
        <Input
          label={variable.name}
          value={value}
          placeholder={variable.name}
          onChange={handleChange}
          error={errorMessage}
        />
      )}
      {variable.type === "date" && (
        <Input
          type="date"
          label={variable.name}
          value={value}
          placeholder={variable.name}
          onChange={handleChange}
          error={errorMessage}
        />
      )}
    </FormRow>
  );
};
